import flagIcons from './flagIcons';
import fontawesome from './fontawesome';

export default {
  fontawesome,
  flagIcons,
};
